// third-party
import { createSlice } from '@reduxjs/toolkit';

// project import
import CalendarDto, { CalendarStatus } from 'common/dto-types/calendar-dto';

type CalendarSliceStates = {
    data?: CalendarDto;
    newStatus: CalendarStatus;
    isSettingFormOpen: boolean;
    isVenuesFormOpen: boolean;
    isTeamsFormOpen: boolean;
    isImportMatchesFormOpen: boolean;
    isArchiveConfirmDialogOpen: boolean;
};

const initialState: CalendarSliceStates = {
    newStatus: CalendarStatus.Active,
    isSettingFormOpen: false,
    isVenuesFormOpen: false,
    isTeamsFormOpen: false,
    isImportMatchesFormOpen: false,
    isArchiveConfirmDialogOpen: false,
};

// ==============================|| CALENDAR - SLICE ||============================== //

const calendar = createSlice({
    name: 'calendar',
    initialState,
    reducers: {
        setData(state, action) {
            state.data = action.payload;
        },

        openCreateForm(state) {
            state.isSettingFormOpen = true;
        },

        openSettingForm(state, action) {
            const data = action.payload;
            state.data = data;
            state.isSettingFormOpen = true;
        },

        closeSettingForm(state) {
            state.data = undefined;
            state.isSettingFormOpen = false;
        },

        openVenuesForm(state, action) {
            const data = action.payload;
            state.data = data;
            state.isVenuesFormOpen = true;
        },

        closeVenuesForm(state) {
            state.data = undefined;
            state.isVenuesFormOpen = false;
        },

        openTeamsForm(state, action) {
            const data = action.payload;
            state.data = data;
            state.isTeamsFormOpen = true;
        },

        closeTeamsForm(state) {
            state.data = undefined;
            state.isTeamsFormOpen = false;
        },
        openImportMatchesForm(state, action) {
            const data = action.payload;
            state.data = data;
            state.isImportMatchesFormOpen = true;
        },

        closeImportMatchesForm(state) {
            state.data = undefined;
            state.isImportMatchesFormOpen = false;
        },

        openCalendarStatusConfirmDialog(state, action) {
            const data = action.payload.data;
            state.data = data;
            state.newStatus = action.payload.newStatus;
            state.isArchiveConfirmDialogOpen = true;
        },
        closeCalendarStatusConfirmDialog(state) {
            state.data = undefined;
            state.newStatus = CalendarStatus.Active;
            state.isArchiveConfirmDialogOpen = false;
        },
    },
});

export default calendar.reducer;

export const {
    setData,
    openCreateForm,
    openSettingForm,
    closeSettingForm,
    openVenuesForm,
    closeVenuesForm,
    openTeamsForm,
    closeTeamsForm,
    openImportMatchesForm,
    closeImportMatchesForm,
    openCalendarStatusConfirmDialog,
    closeCalendarStatusConfirmDialog,
} = calendar.actions;
